import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/main.scss'
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
const domNode = document.getElementById('root');
domNode.style.height = '100%';
const root = createRoot(domNode)
root.render(<Provider store={store}><App /></Provider>)

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
